import {PAGE_TYPE_ORG_TOPIC, PAGE_TYPE_SUBS_TOPIC, PAGE_TYPE_TOPIC} from '@udemy/browse-utils';
import {UDData} from '@udemy/ud-data';

import {PRESET_ALL} from './constants';
import {isOrgTopicPage, isSubsTopicPage, TopicPageType} from './types/page';
import {Topic} from './types/topic';

export const getPageObjectIdFromTopic = (topic: Topic) => {
    return parseInt(topic.id, 10);
};

export const getPageType = (udData: UDData, isConsumerSubsSubscriber: boolean): TopicPageType => {
    if (udData.Config.brand.has_organization) {
        return PAGE_TYPE_ORG_TOPIC;
    }
    if (isConsumerSubsSubscriber) {
        return PAGE_TYPE_SUBS_TOPIC;
    }
    return PAGE_TYPE_TOPIC;
};

export const getPrimaryHeading = ({
    topic,
    topicTitle,
    presetValue,
    pageType,
}: {
    topic: Topic;
    topicTitle: string;
    presetValue: string;
    pageType: TopicPageType;
}): string => {
    const showOnlyTopicName = isSubsTopicPage(pageType) || isOrgTopicPage(pageType);
    if (presetValue === PRESET_ALL && showOnlyTopicName) {
        return topic.name;
    }
    return topicTitle;
};

export const getLocalizedEnrollmentStat = (enrollmentStat: string, locale: string): string => {
    if (!enrollmentStat) {
        return enrollmentStat;
    }
    // The API may return enrollmentStat already pre-formatted with locale-specific
    // thousand separators (e.g., "1,234" in en_US or "1.234" in es_ES). Strip
    // non-digits to recover the raw integer so we can re-format with the current
    // frontend locale (which may differ from the one the API formatted with).
    const cleanedEnrollmentStat = enrollmentStat.replace(/\D/g, '');

    try {
        return parseInt(cleanedEnrollmentStat).toLocaleString(locale.replace('_', '-') || 'en-US');
    } catch {
        return enrollmentStat;
    }
};
